import { Minus, Plus } from 'lucide-react';
import type { ReactNode } from 'react';

export function PolicyPoint({
  type,
  children,
}: {
  type: 'benefit' | 'tradeoff';
  children: ReactNode;
}) {
  const Icon = type === 'benefit' ? Plus : Minus;
  return (
    <li className="flex items-start gap-2">
      <Icon className="mt-0.5 size-4 shrink-0 text-muted-foreground" aria-hidden />
      <span className="text-sm text-foreground">{children}</span>
    </li>
  );
}
